(function () {
  function initProductGallery() {
    const gallery = document.querySelector(".product-gallery-layout");

    if (!gallery || gallery.classList.contains("gallery-initialized")) return;

    gallery.classList.add("gallery-initialized");

    const thumbTrack = gallery.querySelector("#thumbTrack");
    const thumbs = [...gallery.querySelectorAll(".thumb")];
    const mainImages = [...gallery.querySelectorAll(".product-image-link")];
    const btnUp = gallery.querySelector(".thumb-up");
    const btnDown = gallery.querySelector(".thumb-down");

    if (!thumbTrack || !thumbs.length) return;

    let currentThumbIndex = 0;

    const getThumbStep = () => {
      if (!thumbs[0]) return 0;

      const thumbStyle = window.getComputedStyle(thumbs[0]);
      const gap = parseFloat(thumbStyle.marginBottom || 12);

      return thumbs[0].offsetHeight + gap;
    };

    const getVisibleThumbs = () => 4;

    const getMaxIndex = () => {
      return Math.max(0, thumbs.length - getVisibleThumbs());
    };

    const updateThumbSlider = () => {
      const step = getThumbStep();

      thumbTrack.style.transform = `translateY(-${currentThumbIndex * step}px)`;

      if (btnUp) {
        btnUp.disabled = currentThumbIndex <= 0;
      }

      if (btnDown) {
        btnDown.disabled = currentThumbIndex >= getMaxIndex();
      }
    };

    const setActiveImage = (imageId) => {
      thumbs.forEach((thumb) => {
        thumb.classList.toggle("active", thumb.dataset.imageId === imageId);
      });

      mainImages.forEach((image) => {
        image.classList.toggle("hidden", image.dataset.imageId !== imageId);
      });
    };

    // 🔥 CORE FIX: ensure active thumb visible on reload
    const syncActiveThumbOnLoad = () => {
      const activeIndex = thumbs.findIndex((t) =>
        t.classList.contains("active"),
      );

      if (activeIndex === -1) {
        updateThumbSlider();
        return;
      }

      const visible = getVisibleThumbs();
      const max = getMaxIndex();

      if (activeIndex < visible) {
        currentThumbIndex = 0;
      } else {
        currentThumbIndex = Math.min(activeIndex - visible + 1, max);
      }

      updateThumbSlider();
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener("click", () => {
        const imageId = thumb.dataset.imageId;

        setActiveImage(imageId);

        const maxIndex = getMaxIndex();

        if (index < currentThumbIndex) {
          currentThumbIndex = index;
        } else if (index >= currentThumbIndex + getVisibleThumbs()) {
          currentThumbIndex = Math.min(
            index - getVisibleThumbs() + 1,
            maxIndex,
          );
        }

        updateThumbSlider();
      });
    });

    if (btnDown) {
      btnDown.addEventListener("click", () => {
        if (currentThumbIndex < getMaxIndex()) {
          currentThumbIndex++;
          updateThumbSlider();
        }
      });
    }

    if (btnUp) {
      btnUp.addEventListener("click", () => {
        if (currentThumbIndex > 0) {
          currentThumbIndex--;
          updateThumbSlider();
        }
      });
    }

    window.addEventListener("resize", updateThumbSlider);

    updateThumbSlider();

    // 🔥 IMPORTANT: wait for DOM + Shopify variant render
    requestAnimationFrame(() => {
      setTimeout(syncActiveThumbOnLoad, 50);
    });
  }

  document.addEventListener("DOMContentLoaded", initProductGallery);
  document.addEventListener("shopify:section:load", initProductGallery);
})();
